import { defineMessages } from 'react-intl'

const messages = defineMessages({
  altVersionBtnEustat: {
    id: 'RegionOverview.altVersionBtnEustat',
    description: 'Botón para cambiar a Eustat',
    defaultMessage: 'Cambiar a versión EUSTAT'
  },
  altVersionBtnEurostat: {
    id: 'RegionOverview.altVersionBtnEurostat',
    description: 'Botón para cambiar a Eurostat',
    defaultMessage: 'Cambiar a versión EUROSTAT'
  },
  alertNewReportPanel: {
    id: 'RegionOverview.alertNewReportPanel',
    description: 'Banner de anuncio del nuevo panel',
    defaultMessage: '<h4>¡NUEVO!</h4>Accede al <a href="{reportPanelLink}">panel de diagnóstico</a> del Informe de Competitividad del País Vasco 2025<a href="{reportPanelLink}">aquí</a>'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/components/RegionOverview/messages.js